import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as yup from "yup";
import { CustomerProfileResponse } from "../CustomerProfile/CustomerProfile.constants";

export type Customer = {
  id: number;
  fullname: string;
  description: string;
  phone_number: string;
  phone_number2?: string;
  phone_number3?: string;
  country: string;
  district: string;
  neighbourhood: string;
  street: string;
  flat_number: string;
  lang: string;
  long: string;
  address_description: string;
  is_active: boolean;
  is_visible: boolean;
  status: number;
};

export interface CustomerListResponse {
  count: number;
  next: any;
  previous: any;
  results: Array<Customer>;
  status: number;
}

export interface CustomerModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Customer;
}

export interface CustomerProfilModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: CustomerProfileResponse;
  mutate: UseMutateFunction<
    CustomerProfileResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export interface CustomerAddRequest {
  name: string;
  description: string;
  date: Date;
  person_who_assign_id?: string | null | number;
  assingPersonName?: string;
}

export interface CustomerAddResponse {
  name: string;
  description: string;
  date: Date;
  person_who_assign_id: Customer;
  status: number;
}

export interface CustomerUpdateResponse {
  id: number;
  remaining_date: Date;
  remaining_days: string;
  fullname: string;
  description: string;
  phone_number: string;
  country: string;
  district: string;
  neighbourhood: string;
  street: string;
  flat_number: string;
  lang: string;
  long: string;
  address_description: string;
  status: number;
}

export interface CustomerDeleteRequest {
  id: string;
}

export interface CustomerDeleteResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface CustomerDeleteModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Customer;
}

export interface CustomerDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Customer;
}

export interface CustomerUpdateRequest {
  id?: number;
  fullname: string;
  phone_number: string;
  phone_number2?: any;
  phone_number3?: any;
  country?: string;
  district?: string;
  neighbourhood?: string;
  street?: string;
  flat_number?: string;
  lang?: string;
  long?: string;
  address_description?: string;
  is_active?: boolean;
  is_visible?: boolean;
  sms_returned_back?: boolean;
}

export interface CustomerDeleteRequest {
  id: string;
  is_active: boolean;
  is_visible: boolean;
}

export const customerUpdateSchema = yup.object().shape({
  fullname: yup.string().required("Müşteri adı boş bırakılamaz"),
  phone_number: yup
    .string()
    .required("Telefon numarası boş bırakılamaz")
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
  phone_number2: yup
    .string()
    .transform((value) => (value === "" ? undefined : value))
    .nullable()
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
  phone_number3: yup
    .string()
    .transform((value) => (value === "" ? undefined : value))
    .nullable()
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
});
export const assignType = {
  ASSING_OWN: "ME",
  ASSING_ALL: "ALL",
  ASSING_PERSON: "PERSON",
};

export const assignPersonOptions = [
  { key: "Herkese", value: assignType.ASSING_ALL },
  { key: "Kendime", value: assignType.ASSING_OWN },
  { key: "Çalışan", value: assignType.ASSING_PERSON },
];

export const assignFormatter = (selectedId?: string, userId?: number) => {
  if (selectedId == userId) return assignType.ASSING_OWN;
  if (selectedId != userId && selectedId !== undefined)
    return assignType.ASSING_PERSON;

  return assignType.ASSING_ALL;
};
